(function (angular, app) {
    "use strict";
    
   angular.module(app.modules.group.name)
      .factory(app.modules.group.services.groups, GroupServiceFactory);
      
   GroupServiceFactory.$inject = ["$q"
       , app.modules.common.services.http
       , app.modules.common.constants.appsettings
       , app.modules.common.services.functions
   ];
   
   function GroupServiceFactory($q, $http
       , ggSettings
       , ggFunctions
       ) {
      
      var _searchTypes = {
         byGroupName : 1
         , byIndividual : 2
         , byPopular : 3
      }
      


      var _setup = {
          insertGroup: function (data) {
             var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.detail;
             var form = {};
             form.name = data.groupName;
             form.isPrivate = data.isPrivate;
             form.type = "Group";
             form.isActive = data.isActive;
             form.themeId = data.themeId;
             form.isUserHandicapUpdateAllowed = data.isUserHandicapUpdateAllowed;
             form.isAdminRestricted = data.isAdminRestricted;
             form.handicapType = data.handicapType;
             // Post the data, but don't transform it.
             return $http.post(apipath, form, false);
          }
          , updateGroup: function (data) {
             var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.detail + "(" + data.groupId + ")";
             var form = {};
             form.name = data.name;
             form.isPrivate = data.isPrivate;
             form.type = "Group";
             form.isActive = data.isActive;
             form.themeId = data.themeId;
             form.isUserHandicapUpdateAllowed = data.isUserHandicapUpdateAllowed;
             form.isAdminRestricted = data.isAdminRestricted;
             form.handicapType = data.handicapType;
             // Post the data, but don't transform it.
             return $http.put(apipath, form);
          }
      }

      var _membership = {
         insertGroupMembership: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.membership;
            var form = {};
            form.groupId = data.groupId;
            form.memberId = data.memberId;
            form.expirationDate = data.expirationDate;
            form.isActive = data.isActive;
            // Post the data, but don't transform it.
            return $http.post(apipath, form, false);
         }
         , updateGroupMembership: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.membership + "(" + data.membershipId + ")";
            var form = {};
            form.isActive = data.isActive;
            return $http.put(apipath, form, false);
         }
         , deleteGroupMembership: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.membership + "(" + data.membershipId + ")";
            return $http.delete(apipath, {});
         }
         , fetchGroupMembership: function (groupId, memberId) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.membership;
            var qry = "?$filter=groupId eq " + groupId + " and memberId eq " + memberId;
            var exp = "&$expand=handicaps";
            // Post the data, but don't transform it.
            return $http.get(apipath + qry + exp, {});
         }
         , fetchGroupMembershipDetail: function (membershipId) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.membership + "(" + membershipId+ ")";
            var qry = "";
            var exp = "?$expand=handicaps";
            // Post the data, but don't transform it.
            return $http.get(apipath + qry + exp, {});
         }
         , updateGroupHandicap: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.handicap + "(" + data.handicapId + ")";
            var qry = "";
            var exp = "";
            var form = {
               value: data.handicap 
               , effectiveOn: ggFunctions.formatDateString(null, 'yyyy-mm-dd', null)
            }
            // Post the data, but don't transform it.
            return $http.put(apipath, form);
         }
         , insertGroupHandicap: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.handicap;
            var qry = "";
            var exp = "";
            var form = {
               value: data.handicap
               , effectiveOn: ggFunctions.formatDateString(null, 'yyyy-mm-dd', null)
               , id : data.membershipId
            }
            // Post the data, but don't transform it.
            return $http.post(apipath, form);
         }
         , fetchGroupHandicap : function(data){ // groupId, membershipId
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.handicap;
            var qry = "?$filter=membershipId eq " + data.membershipId;
            var exp = "";
            // Post the data, but don't transform it.
            return $http.get(apipath + qry, {});
         }

         , autoUpdateGroupHandicap: function (data) {
            
            var membershipId = data.membershipId;
            var memberId = data.memberId;
            var groupId = data.groupId;
            var handicap = data.handicap;
            var effectiveOn = data.effectiveOn;

            // Return Data
            var rval = {
               status: "400"
               , statusMsg: ""
               , data: {
                  membershipId: membershipId
                  , groupId: groupId
                  , handicapId : 0
               }
            }

            // Fetch
            var _fetch = function (groupId, memberId, membershipId) {
               if (membershipId) {
                  return _membership.fetchGroupMembershipDetail(membershipId).then(function (data) {
                     if (data && data.status == "200") {
                        rval.status = "000";
                        rval.statusMsg = "";
                        if (data.data) {
                           var membership = data.data;
                           if (membership.handicaps.length > 0) {
                              rval.data.handicapId = membership.handicaps[0].id;
                           }
                        }
                     }
                     return;
                  }, function (error) {
                     rval.statusMsg = "An error occurred checking for a handicap record.";
                     return;
                  });
               } else {
                  return _membership.fetchGroupMembership(groupId, memberId).then(function (data) {
                     if (data && data.status == "200") {
                        rval.status = "000";
                        rval.statusMsg = "";
                        if (data.data.value && data.data.value.length > 0) {
                           var membership = data.data.value[0];
                           rval.data.membershipId = membership.id;
                           if (membership.handicaps.length > 0) {
                              rval.data.handicapId = membership.handicaps[0].id;
                           }
                        }
                     }
                     return;
                  }, function (error) {
                     rval.statusMsg = "An error occurred checking for a handicap record.";
                     return;
                  });
               }
            }
            // Insert
            var _insert = function (form) {
               return _membership.insertGroupHandicap(form).then(function (data) {
                  if (data && data.status == "201") {
                     rval.status = "200";
                     rval.statusMsg = "The handicap has been added."
                     rval.data.handicapId = data.data.id;
                  }
                  return;
               }, function (error) {
                  rval.statusMsg = "An error occurred inserting a new handicap record.";
                  return;
               });
            }
            // UPdate
            var _update = function (form) {
               return _membership.updateGroupHandicap(form).then(function (data) {
                  if (data && data.status == "200") {
                     rval.status = "200";
                     rval.statusMsg = "The handicap has been updated."
                  }
                  return rval;
               }, function (error) {
                  rval.statusMsg = "An error occurred updating the existing handicap record.";
                  return;
               });
            }

            // Process
            return _fetch(groupId, memberId, membershipId).then(function (data) {
               if (rval.data.handicapId == 0) {
                  return _insert({ membershipId: rval.data.membershipId, groupId: groupId, handicap: handicap, effectiveOn: effectiveOn });
               } else {
                  return _update({ handicapId: rval.data.handicapId, handicap: handicap, effectiveOn: effectiveOn });
               }
            }).then(function () {
               return $q.resolve(rval);
            });


         }
         , autoJoinGroup: function (data) {

            var memberId = data.memberId
            var groupId = data.groupId;
            
            // Return Data
            var rval = {
               status: "400"
               , statusMsg: ""
               , data: {
                  memberId: memberId
                  , groupId: groupId
                  , membershipId: 0
                  , membership: {}
               }
            }

            // Fetch
            var _fetch = function(groupId, memberId){
               return _membership.fetchGroupMembership(groupId, memberId).then(function(data){
                  if (data && data.status == "200") {
                     rval.status = "000";
                     rval.statusMsg = "";
                     if (data.data.value.length > 0) {
                        rval.data.membershipId = data.data.value[0].id;
                        rval.data.membership = data.data.value[0];
                     }
                  }
                  return;
               }, function(error){
                  rval.statusMsg = "An error occurred checking for group membership.";
                  return;
               });
            }
            // Insert
            var _insert = function(form){
               return _membership.insertGroupMembership(form).then(function(data){
                  if (data && data.status == "201") {
                     rval.status = "201";
                     rval.statusMsg = "The user has been added."
                     rval.data.membershipId = data.data.id;
                  }
                  return;
               }, function(error){
                  rval.statusMsg = "An error occurred inserting a new group membership.";
                  return;
               });
            }
            // UPdate
            var _update = function(form){
               return _membership.updateGroupMembership(form).then(function(data){
                  if (data && data.status == "200") {
                     rval.status = "200";
                     rval.statusMsg = "The user has been added."
                  }
                  return rval;  
               }, function(error){
                  rval.statusMsg = "An error occurred updating the existing group membership.";
                  return;
               });
            }
            
            // Process
            return _fetch(groupId, memberId).then(function (data) {
               if (rval.data.membershipId == 0){
                  return _insert({ memberId: memberId, groupId: groupId, isActive: true, expiresOn: null });
               } else {
                  if (rval.data.membership.isActive) {
                     return _update({membershipId : rval.data.membershipId, isActive : true});
                  } else {
                     return $q.resolve();
                  }
                  
               }
            }).then(function(){
               return $q.resolve(rval);  
            });
              
         }
         , autoLeaveGroup: function (data) {

            var memberId = data.memberId
            var groupId = data.groupId;

            var rval = {
               status: "400"
               , statusMsg: ""
               , data: {
                  memberId: memberId
                  , groupId: groupId
                  , membershipId: 0
               }
            }

            // Fetch
            var _fetch = function (groupId, memberId) {
               return _membership.fetchGroupMembership(groupId, memberId).then(function (data) {
                  if (data && data.status == "200") {
                     rval.status = "000";
                     rval.statusMsg = "";
                     if (data.data.value.length > 0) {
                        rval.data.membershipId = data.data.value[0].id;
                     } else {
                        rval.statusMsg = "The group membership does not exist.";
                     }
                  }
                  return;
               }, function (error) {
                  rval.statusMsg = "An error occurred checking for group membership.";
                  return;
               });
            }

            var _delete = function (form) {
               return _membership.deleteGroupMembership(form).then(function (data) {
                  if (data && data.status == "204") {
                     rval.status = "200";
                     rval.statusMsg = "The user has been updated."
                  }
                  return;
               }, function (error) {
                  rval.status = "400";
                  rval.statusMsg = "There was an error removing the group membership.";
                  return;
               });
            }

            return _fetch(groupId, memberId).then(function (data) {
               if (rval.data.membershipId > 0) {
                  return _delete({ membershipId: rval.data.membershipId });
               } else {
                  return $q.resolve();
               }
            }).then(function () {
               return $q.resolve(rval);
            });
         }
      }

      var _search = {
          fetchGroupDetail: function (data) {
             var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.detail + "(" + data.groupId + ")?";
             var exp = "$expand=createdBy($select=id,firstName,lastName)";
              return $http.get(apipath + exp, {});
          }
         , fetchGroupSearch: function (data) {
             // Build Search
             var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.search;
             var qry = "?$top=50&$filter=type eq " + ggSettings.grpapi.namespace + ".GroupType'Group' and isActive eq true"
             var exp = "&$expand=createdBy($select=id,firstName,lastName,photo)";
             var ord = "&$orderby=name"

             if (data.name) {
                 var name = data.name.trim();
                 if (isNaN(name)) {
                     // Name Only
                     qry = qry + " and startswith(name,'" + name + "')"
                 } else {
                     // Group Id
                     qry = qry + " and id eq " + name;
                 }
             }
             if (data.createdById) {
                 // Group Leader
                 qry = qry + " and createdBy/id eq " + data.createdById;
             }
             if (!data.isPrivate) {
                 qry = qry + " and isPrivate eq false";
             }


             // Fetch
             return $http.get(apipath + qry + exp + ord, {});
         }
         , fetchGroupsNearMe: function (data) {
             // Build Search
             var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.nearme;
             apipath = apipath.replace("{id}", "(" + app.Member.Detail.id + ")");
             var qry = ""
             var exp = "";
             var ord = ""

             // Fetch
             return $http.get(apipath + qry + exp + ord, {});
         }
         , fetchClubSearch: function (data) {
            // Build Search
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.group.search;
            var qry = "?$top=50&$filter=type eq " + ggSettings.grpapi.namespace + ".GroupType'Club' and isActive eq true"
            var exp = "&$expand=" + ggSettings.grpapi.namespace + ".Member($select=id,firstName,lastName)";
            var ord = "&$orderby=name"

            if (data.name) {
               var name = data.name.trim();
               if (isNaN(name)) {
                  // Name Only
                  qry = qry + " and startswith(name,'" + name + "')"
               } else {
                  // Group Id
                  qry = qry + " and id eq " + name;
               }
            }
            // does not exist in api yet.
            if (data.createdByMemberId) {
               // Group Leader
               qry = qry + " and GNAPI.Member/id eq " + data.createdByMemberId;
            }


            // Fetch
            return $http.get(apipath + qry + exp + ord, {});
         }
         , fetchGroupSearchByMember: function (data) {
             // Build Search
             var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.membership;
             var qry = "?$top=50&$filter=memberId eq " + data.memberId + " and group/type eq " + ggSettings.grpapi.namespace + ".GroupType'Group' and isActive eq true and group/isActive eq true&$expand=group($expand=createdBy($select=id,firstName,lastName,photo)),handicaps"
             var ord = "&$orderby=group/name";
             return $http.get(apipath + qry + ord, {}).then(function (data) {
                if (data && data.status == "200") {
                   var res = {
                      status: 200
                      , data: {
                         value : []
                      }
                   }

                   for (var x = 0; x < data.data.value.length; x++) {
                      var grp = data.data.value[x];
                      if (grp.group) {
                         res.data.value.push(grp);
                      }
                   }

                   return res;
                }

             });
          }
         , fetchClubSearchByMember: function (data) {
            // Build Search
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.club.memberships;
            var qry = "?$top=50&$filter=memberId eq " + data.memberId + "&$expand=club,handicaps"
            var ord = "&$orderby=club/name";
            return $http.get(apipath + qry + ord, {});
         }
          
      }
         
      var service = {
          group : null // store temp group here
         , searchTypes : _searchTypes
         , search: _search
         , setup: _setup
         , membership : _membership
      }
      
      return service;
   }
}(angular, app));

